module.exports = __webpack_public_path__ + "img/暂无任何商品.f6d19984.png";